import { createFileRoute } from '@tanstack/react-router'
import { lazy, Suspense } from 'react'

// The curation queue loads in its own chunk: only curators and admins need it (spec 031).
const CuratePage = lazy(() => import('../components/curate/CuratePage.js'))

export const Route = createFileRoute('/curate')({
  component: () => (
    <Suspense fallback={null}>
      <CuratePage />
    </Suspense>
  ),
})
